import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { numberWithCommas } from "../../../../utils";

/** Above the table's sticky header and inputs, below dialogs. */
const BAR_Z_INDEX = 3;

interface UnsavedChangesBarProps {
  changeCount: number;
  busy: boolean;
  onDiscard: () => void;
  onSave: () => void;
}

/** Pinned to the bottom of the page while the book has edits nobody has saved yet. */
export default function UnsavedChangesBar({
  changeCount,
  busy,
  onDiscard,
  onSave,
}: UnsavedChangesBarProps) {
  return (
    <Paper
      elevation={6}
      sx={{ position: "sticky", bottom: 16, zIndex: BAR_Z_INDEX, mt: 2 }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
      >
        <Typography variant="body2" fontWeight={600}>
          {numberWithCommas(changeCount)} การเปลี่ยนแปลงยังไม่บันทึก
        </Typography>
        <Stack direction="row" gap={1}>
          <Button disabled={busy} onClick={onDiscard}>
            ยกเลิก
          </Button>
          <Button variant="contained" loading={busy} onClick={onSave}>
            บันทึก
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
